import React, { useEffect, useState } from 'react';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar'
import { useMyContext } from '../../../context/MyContext';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { FcPrint } from "react-icons/fc";
import { Base_Url, dashboard, shipmentlabel, cancleOrder, deleteShipment, userdata, forwardorderlistall, shipmentList, Url_For_View_Document, priceEstimator, bulkshipmentlabel, allwarehouseslist } from '../../../config/config';
import { useNavigate } from 'react-router-dom';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { ShoppingCart, Package, Wallet, Eye, ArrowRight } from 'lucide-react';
import { FaRupeeSign, FaShopify } from "react-icons/fa";
import ViewAllShipment from '../../../component/b2c/models/ViewAllShipment';
import { useAuth } from '../../../routes/Auth';
import Spinner from '../../../component/spinner/spinner';
import { FaJediOrder } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import Swal from 'sweetalert2';
import ImageOfferSlider from '../../../component/Alloffers/alloffer';
import { FaCheckCircle } from "react-icons/fa";
// import OffersSlider from '../../../component/offerSlider/offerSlider';
import { FaTruck } from "react-icons/fa";
import { IoMdAirplane } from "react-icons/io";
import { BarChart, Bar, PieChart, Pie, Cell, Area, AreaChart, Legend } from 'recharts';
// import { Edit, Trash2, Ship } from "lucide-react";
import ViewRateForwardShipment from '../../../component/b2c/models/ViewRateForwordShipmet'
import axios from 'axios';
import FullPageLoader from '../../../component/fullPageLoader/fullPageLoader';


const DashBoard = () => {
  const [wareHouseList, setwareHouseList] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [OID, setOID] = useState("");
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [activeView, setActiveView] = useState('overview');
  const [selectedRows, setSelectedRows] = useState([]);
  const [shipData, setShipData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedShipment, setSelectedShipment] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [shipments, setShipments] = useState([]);
  const [error, setError] = useState(null);
  const [filteredShipmemt, setFilteredShipment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totaldata, setTotalData] = useState();
  const navigate = useNavigate();
  const navigateForTrack = useNavigate();
  const { logout } = useAuth()
  const { profile_flag, setProfile_flag, setorderId } = useMyContext()
  const [isloading, isSetLoading] = useState(false);
  const [loadingOrderId, setLoadingOrderId] = useState(null);
  const [isPopupOpenForShip, setIsPopupOpenForShip] = useState(false)
  const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const [loadingOrderIdShip, setLoadingOrderIdShip] = useState(null);
  // const profile_Flag = localStorage.getItem('profile_flag');

  const dashboardUrl = Base_Url + dashboard;
  const cancleOrderApi = Base_Url + deleteShipment;

  useEffect(() => {
    fetchOrderData();
    totalData();
    fetchUserData()
  }, []);


  const handleClick = (orderID) => {
    setorderId(orderID);
    navigateForTrack("/shipments/tracking ");
  }

  const fetchWareHouseList = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const headers = new Headers({
      'token': token,
      'cus_id': cusid,
      'Content-Type': 'application/json'
    });
    try {
      const response = await fetch(Base_Url + allwarehouseslist, {

        method: 'GET',
        headers: headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = data.data.map(warehouse => ({
        value: warehouse.id,
        label: warehouse.name,
        pincode: warehouse.pincode
      }));
      setwareHouseList(transformedData)
    } catch (error) {
      console.error('Error:', error);
    }
  }


  const fetchUserData = async () => {
    const url = Base_Url + userdata;
    setIsPageLoading(true);
    if (cusid) {
      try {
        const response = await fetch(url + "/" + cusid, {
          method: 'GET',
          headers: {
            'token': token,
            'cus_id': cusid,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        setProfile_flag(result.data.profile_flag)
        setIsPageLoading(false);

      } catch (error) {
        console.error('Error fetching user data:', error);
        setIsPageLoading(false);
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate('/login')
    logout()
    localStorage.removeItem('cus_id')
    localStorage.removeItem('token')
  }

  const fetchOrderData = async () => {
    // const url = Base_Url + shipmentList;
    const url = `${Base_Url}${shipmentList}?status=pending`;
    setLoading(true);
    setIsPageLoading(true);
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setShipments(data.data || []);
        setOID(data.data[0].order_id);
        setFilteredShipment(data.data.slice(0, 9));
        setLoading(false);
        setIsPageLoading(false);
      }
      else if (data.status === "FAIL" && data.message === "Unauthorized access - Invalid token") {
        toast.error(data.message + " Please Login Again");
        handleLogout();
        setLoading(false);
        setIsPageLoading(false);
      }
      else {
        setError('Error fetching data: ' + data.message);
        setLoading(false);
        setIsPageLoading(false);
      }
    } catch (error) {
      setError('API error: ' + error.message);
      setLoading(false);
      setIsPageLoading(false);
    } finally {
      // setLoading(false);
    }
  };

  const getShipmentStats = () => {

    const stats = {};
    shipments.forEach(shipment => {
      const partner = shipment?.partner || 'unknown';
      const status = shipment.status?.toLowerCase() || 'unknown';

      if (!stats[partner]) {
        stats[partner] = {
          partner: shipment.partner || 'Unknown',
          Manifested: 0,
          Inansit: 0,
          pending: 0,
          ofd: 0,
          delivered: 0,
          rto: 0,
          lost: 0,
          total: 0
        };
      }

      // Map statuses to categories
      if (status.includes('Manifest')) {
        stats[partner].manifested++;
      } else if (status.includes('in Transit') || status.includes('pickup') || status.includes('dispatched')) {
        stats[partner].inTransit++;
      } else if (status.includes('pending') || status.includes('ready')) {
        stats[partner].pending++;
      } else if (status.includes('ofd') || status.includes('out for_delivery') || (status.includes('out for pickup'))) {
        stats[partner].ofd++;
      } else if (status.includes('delivered') || (status.includes('Delivered to consignee'))) {
        stats[partner].delivered++;
      } else if (status.includes('rto') || status.includes('return')) {
        stats[partner].rto++;
      } else if (status.includes('lost') || status.includes('missing')) {
        stats[partner].lost++;
      } else {
        stats[partner].pending++; // Default to pending for unknown statuses
      }

      stats[partner].total++;
    });

    return Object.values(stats);
  };

  // const shipmentStats = getShipmentStats();

  const getPartnerLogo = (partner) => {
    const partnerLower = partner?.toLowerCase() || '';

    if (partnerLower === 'delhivery') {
      return isDarkMode ? "/assets/images/DELHIVERYWhite.png" : "/assets/images/Delhivery.png";
    } else if (partnerLower === 'ecom') {
      return isDarkMode ? "/assets/images/logoecom.svg" : "/assets/images/ecom-express-logo.png";
    } else if (partnerLower === 'ekart') {
      return "/assets/images/ekart.png";
    }
    return null;
  };

  const totalData = async () => {
    setIsPageLoading(true);
    try {
      const response = await fetch(dashboardUrl, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setTotalData(data || []);
        setIsPageLoading(false);
        // setFilteredShipment(data.data.slice(0,9));
      } else {
        setError('Error fetching data: ' + data.message);
        setIsPageLoading(false);
      }
    } catch (error) {
      setError('API error: ' + error.message);
      setIsPageLoading(false);
    } finally {

    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filterShipment = shipments;
  const currentItems = filterShipment.slice(indexOfFirstItem, indexOfLastItem);
  // const total = shipments.reduce((sum, shipment) => sum + parseFloat(shipment.debit_amount), 0);

  const handleViewClick = (shipment) => {
    setSelectedShipment(shipment)
    fetchWareHouseList();
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleViewClickForShip = (shipment) => {
    setSelectedShipment(shipment)
    setIsPopupOpenForShip(true);

  }

  const handleCloseForShip = () => {
    setIsPopupOpenForShip(false);
  };

  const data = totaldata?.chartData?.monthlyData;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      // Select only rows that have a partner
      const selectableIndexes = currentItems
        .map((item, idx) => (item.partner ? idx : null))
        .filter(idx => idx !== null);
      setSelectedRows(selectableIndexes);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleRowSelect = (index) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(index);
      let updatedSelection;

      if (isSelected) {
        updatedSelection = prev.filter(i => i !== index);
      } else {
        updatedSelection = [...prev, index];
      }

      // Check if all rows with partner are selected
      const totalSelectable = currentItems.filter(item => item.partner).length;
      const selectedWithPartner = updatedSelection.filter(i => currentItems[i]?.partner).length;

      setSelectAll(selectedWithPartner === totalSelectable);

      return updatedSelection;
    });
  };


  const handlePrintLabel = async (orderId) => {
    setLoadingOrderId(orderId);
    try {
      const response = await fetch(Base_Url + shipmentlabel, {
        method: 'POST',
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ order_id: orderId }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const printUrl = data?.DownloadLink;
        if (printUrl) {
          const printLabel = Base_Url + printUrl
          window.open(printLabel, '_blank');
        }
        setLoadingOrderId(null);
      }
      else {
        toast.error(data.message || "url is not found please try again !");
        setLoadingOrderId(null);
      }
    } catch (error) {
      setError('API error: ' + error.message);
      setLoadingOrderId(null);
    }
  };

  // const getSelectedOrderIds = () => {
  //   if (selectAll) {
  //     // If all are selected, return all order IDs
  //     return currentItems.map(shipment => shipment.order_id);
  //   } else {
  //     // For individual selections, map correctly to the displayed items
  //     return selectedRows.map(index => {
  //       // Make sure we're accessing the correct item in currentItems
  //       return currentItems[index].order_id;
  //     });
  //   }
  // };

  const getSelectedOrderIds = () => {
    if (selectAll) {
      // Return only those with a truthy `partner`
      return currentItems
        .filter(shipment => shipment.partner)
        .map(shipment => shipment.order_id);
    } else {
      // Return only selected rows that have a partner
      return selectedRows
        .map(index => currentItems[index])
        .filter(shipment => shipment.partner)
        .map(shipment => shipment.order_id);
    }
  };

  const handleDownload = async () => {
    const selectedOrderIds = getSelectedOrderIds();
    const urlForDownloadBulkLabel = Base_Url + bulkshipmentlabel;
    const payload = {
      order_ids: selectedOrderIds
    };

    const headers = {
      token: token,
      cus_id: cusid,
      'Content-Type': 'application/json',
    };
    isSetLoading(true);
    try {
      const response = await fetch(urlForDownloadBulkLabel, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const pdf = data.DownloadLink;
        const downloadPdf = Url_For_View_Document + pdf;
        if (downloadPdf) {
          window.open(downloadPdf, "_blank")
        }
        isSetLoading(false);
      }
      else {
        toast.error(data.message);
        isSetLoading(false);
      }
    } catch (error) {
      console.error('Error downloading orders:', error);
      isSetLoading(false);
    }
  };

  const handleCancelOrder = async (orderId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to cancel this order?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'No',
    });

    if (!confirmResult.isConfirmed) {
      return; // User cancelled
    }


    try {
      setIsPageLoading(true);
      setLoadingOrderIdCancleOrder(orderId); // Show loader on button
      const response = await fetch(`${cancleOrderApi}/${orderId}`, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      if (response.ok) {
        setShipments((prevData) => prevData.filter(item => item.order_id !== orderId)); // Remove canceled order from state
        toast.success("Order canceled successfully!");
        setIsPageLoading(false);
      } else {
        toast.error(`Failed to cancel order: ${data.message}`);
      }
    } catch (error) {
      toast.error(`API error: ${error.message}`);
    } finally {
      setLoadingOrderIdCancleOrder(null);
      setIsPageLoading(false);
    }
  };

  // Navigation handlers for new cards
  const handleNavigateToNDR = () => {
    navigate('/disputes/NDR');
  };

  const handleNavigateToCODRemittance = () => {
    navigate('/cod-remittance');
  };


  const handleShipNow = async (data) => {
    // const { weight } = data;
    // if (weight > 20000) {
    //     Swal.fire({
    //         title: "Weight Limit Exceeded!",
    //         text: "The weight cannot exceed 20kg. Please adjust the value.",
    //         icon: "error",
    //         confirmButtonText: "Okay",
    //     });
    //     return;
    // }

    // setIsSubmitting(true);
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const requestBody = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      product_desc: data.products_desc,
      phone: data.phone,
      city: data.city,
      state: data.state,
      country: "India",
      payment_mode: data.payment_mode,
      total_amount: data.total_amount,
      address_type: "home",
      length: data.length,
      width: data.shipment_width,
      height: data.shipment_height,
      from_pincode: data.pickup_pin_code,
      to_pincode: data.pin,
      // cod_amount: data.codAmount,
      cod_amount: data.cod_amount,
      quantity: "1",
      weight: data.weight,
      shipment_type: "Forward",
      order_id: data.order_id
    };
    try {
      setLoadingOrderIdShip(data.orderId)
      setIsPageLoading(true);
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        // handleViewClickForShip(response.data);
        const enrichedShipment = { ...response.data, order_id: data.order_id };
        handleViewClickForShip(enrichedShipment);
        setIsPageLoading(false);
        setLoadingOrderIdShip(null)
      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
        setLoadingOrderIdShip(null)
        setIsPageLoading(false);
      }

    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
    }
  };

  const courierTable = [
    { partner: 'Delhivary', outForPick: 2, inTransit: 3, ofd: 6, delivered: 10 },
    { partner: 'Ecam', outForPick: 1, inTransit: 4, ofd: 5, delivered: 8 },
    { partner: 'Ekart', outForPick: 3, inTransit: 2, ofd: 4, delivered: 7 },
  ];

  const shipmentStats = [
    {
      partner: 'Delhivery',
      manifested: 145,
      inTransit: 89,
      pending: 23,
      ofd: 67,
      delivered: 234,
      rto: 12,
      lost: 3,
      total: 573
    },
    {
      partner: 'Ecom',
      manifested: 98,
      inTransit: 76,
      pending: 15,
      ofd: 45,
      delivered: 189,
      rto: 8,
      lost: 2,
      total: 433
    },
    {
      partner: 'Ekart',
      manifested: 67,
      inTransit: 54,
      pending: 12,
      ofd: 34,
      delivered: 156,
      rto: 6,
      lost: 1,
      total: 330
    }
  ];

  // const statusColors = {
  //   manifested: '#06bb6d',
  //   inTransit: '#F59E0B',
  //   pending: '#64748B',
  //   ofd: '#8B5CF6',
  //   delivered: '#036a3e',
  //   rto: '#EF4444',
  //   lost: '#475569'
  // };


  // const totalsByPartner = shipmentStats.map(stat => ({
  //   name: stat.partner,
  //   total: stat.total,
  //   delivered: stat.delivered,
  //   pending: stat.pending + stat.manifested + stat.inTransit,
  //   issues: stat.rto + stat.lost
  // }));

  // const statusBreakdown = [
  //   { name: 'Delivered', value: shipmentStats.reduce((sum, stat) => sum + stat.delivered, 0), color: statusColors.delivered },
  //   { name: 'In Transit', value: shipmentStats.reduce((sum, stat) => sum + stat.inTransit, 0), color: statusColors.inTransit },
  //   { name: 'OFD', value: shipmentStats.reduce((sum, stat) => sum + stat.ofd, 0), color: statusColors.ofd },
  //   { name: 'Manifested', value: shipmentStats.reduce((sum, stat) => sum + stat.manifested, 0), color: statusColors.manifested },
  //   { name: 'Pending', value: shipmentStats.reduce((sum, stat) => sum + stat.pending, 0), color: statusColors.pending },
  //   { name: 'RTO', value: shipmentStats.reduce((sum, stat) => sum + stat.rto, 0), color: statusColors.rto },
  //   { name: 'Lost', value: shipmentStats.reduce((sum, stat) => sum + stat.lost, 0), color: statusColors.lost }
  // ].filter(item => item.value > 0);

  // const performanceData = shipmentStats.map(stat => ({
  //   partner: stat.partner,
  //   deliveryRate: ((stat.delivered / stat.total) * 100).toFixed(1),
  //   issueRate: (((stat.rto + stat.lost) / stat.total) * 100).toFixed(1),
  //   total: stat.total
  // }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={`p-3 rounded-lg shadow-lg border ${isDarkMode ? 'bg-gray-800 border-gray-600 text-white' : 'bg-white border-gray-200'}`}>
          <p className="font-semibold mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} style={{ color: entry.color }} className="text-sm">
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`h-screen  flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      {
        profile_flag === "0" && role != "admin" ? <marquee className=" text-red-500 font-medium "> Your Kyc Is Pending Please Contact To The Support Team on support@pickupxpress.com</marquee> : ""
      }
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>
            <Sidebar />
          </div>
        )}
        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />
        <div
          className={`flex-1  overflow-auto  cursor-pointer  transition-all duration-300 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-gray-800" : "bg-white"}`}>
          {/* DashBoard Content */}
          <div className="p-4 md:p-6 min-h-screen transition-all duration-300 rounded-custom">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-6">
              {/* Card 1 - Combined Total Orders */}
              {/* <div className="bg-gradient-to-r from-[#06bb6d] to-[#036a3e] rounded-lg p-4 max-h-[150px] transform transition-transform sm:max-w-[220px]"> */}
              <div
                className={`bg-gradient-to-r from-[#06bb6d] to-[#036a3e] rounded-lg p-4 max-h-[150px] transform transition-all duration-300 hoverL:scale-[105]
              ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
                onClick={() => {
                  // Navigate to NDR page
                  // Replace with your actual navigation logic
                  window.location.href = '/shipments/all'; // or use your router navigation
                }}  >
                <p className="text-white text-lg font-sans">Orders</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.total_order}</p>
                <div className="text-white text-xs font-sans mt-1 space-y-0.5">
                  <div className="flex justify-between">
                    <span>Delivered:</span>
                    <span className="font-medium">{totaldata?.data?.total_delivered}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>COD:</span>
                    <span className="font-medium">{totaldata?.data?.total_cod}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Prepaid:</span>
                    <span className="font-medium">{totaldata?.data?.total_prepaid}</span>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-1">
                  {/* <ShoppingCart className="text-white h-5 w-5" /> */}
                  {/* <span className="text-white text-lg">⋮</span> */}
                </div>
              </div>

              {/* Card 2 - Total NDR (Clickable) */}
              <div
                className={`bg-gradient-to-r from-[#7f04a6] to-[#62059e] rounded-lg p-4 transform transition-transform max-h-[150px] sm:max-w-[220px] cursor-pointer hover:scale-105 ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
                onClick={() => {
                  // Navigate to NDR page
                  // Replace with your actual navigation logic
                  window.location.href = '/disputes/NDR'; // or use your router navigation
                }}
              >
                <p className="text-white text-lg font-sans">NDR & RTO</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.total_all_ndr || '0'}</p>
                {/* <p className="text-white text-sm font-sans">Non-Delivery Reports {totaldata?.data?.month}</p> */}
                <div className="text-white text-xs font-sans mt-1 space-y-0.5">
                  <div className="flex justify-between">
                    <span>NDR:</span>
                    <span className="font-medium">{totaldata?.data?.total_ndr}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>RTO:</span>
                    <span className="font-medium">{totaldata?.data?.total_rto}</span>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-2">
                  <Package className="text-white h-6 w-6" />
                  {/* <span className="text-white text-2xl">⋮</span> */}
                </div>
              </div>

              {/* Card 3 - COD Remittance (Clickable) */}
              <div
                className={`bg-gradient-to-r from-[#a6042b] to-[#e81581] rounded-lg p-4 transform transition-transform max-h-[150px] cursor-pointer hover:scale-105
  ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'}`}
                onClick={() => {
                  const role = localStorage.getItem('role');
                  if (role === 'admin') {
                    window.location.href = '/payments/remmitanceList';
                  } else {
                    window.location.href = '/payments/remmitance';
                  }
                }}
              >
                <p className="text-white text-lg font-sans">COD Remittance</p>
                <p className="text-white text-2xl font-medium">
                  {totaldata?.data?.cod_remittance || '₹0'}
                </p>
                {/* Breakdown like Orders card */}
                <div className="text-white text-xs font-sans mt-1 space-y-0.5">
                  <div className="flex justify-between">
                    <span>Last Remittance:</span>
                    <span className="font-medium">
                      {totaldata?.data?.last_remittance || '₹0'}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span>Next Remittance:</span>
                    <span className="font-medium">
                      {totaldata?.data?.next_remittance || '₹0'}
                    </span>
                  </div>
                </div>

                <div className="flex justify-between items-center mt-1">
                  <FaRupeeSign className="text-white h-5 w-5" />
                </div>
              </div>

              {/* Card 4 - Returns/RTO */}
              {/* <div className={`bg-gradient-to-r from-[#e85a15] to-[#a63904] rounded-lg p-4 transform transition-transform max-h-[150px]  cursor-pointer hover:scale-105 sm:max-w-[220px] ${!isToggleSidebar ? 'sm:max-w-[300px]' : 'sm:max-w-[220px]'}`}
                onClick={() => {
                  // Navigate to NDR page
                  // Replace with your actual navigation logic
                  window.location.href = '/disputes/NDR'; // or use your router navigation
                }}>
                <p className="tbext-white text-lg font-sans">Total RTO</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.total_rto || '0'}</p>
                <p className="text-white text-sm font-sans">Return to Origin {totaldata?.data?.month}</p>
                <div className="flex justify-between items-center mt-2">
                  <svg className="text-white h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414L2.586 7l3.707-3.707a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-white text-2xl">⋮</span>
                </div>
              </div> */}

              {/* Card 5 -  Weight Disputes */}

              <div className={`bg-gradient-to-r from-[#0072bb] to-[#004a76] rounded-lg p-4 max-h-[150px] transform transition-transform  cursor-pointer hover:scale-105 sm:max-w-[220px] ${!isToggleSidebar ? 'sm:max-w-[400px]' : 'sm:max-w-[320px]'} `}
                onClick={() => {

                  const targetUrl = role === 'admin'
                    ? '/disputes/allWeightDisputes'
                    : '/disputes/weight';
                  window.location.href = targetUrl;
                }}>
                <p className="text-white text-lg font-sans">Weight Disputes</p>
                <p className="text-white text-2xl font-medium">{totaldata?.data?.weight_disputes || '₹0'}</p>
                <p className="text-white text-sm font-sans">Total Weight Disputes {totaldata?.data?.month}</p>
                <div className="flex justify-between items-center mt-2">
                  <FaJediOrder className="text-white h-6 w-6" />
                  <span className="text-white text-2xl">⋮</span>
                </div>
              </div>
            </div>

            {/* <OffersSlider /> */}

            {/* <div className="flex space-x-1 mb-6">
              {[
                { id: 'overview', label: 'Overview', icon: '📊' },
                { id: 'performance', label: 'Performance', icon: '🎯' },
                { id: 'distribution', label: 'Distribution', icon: '📈' }
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveView(tab.id)}
                  className={`px-6 py-3 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${activeView === tab.id
                    ? `${isDarkMode ? 'bg-blue-600 text-white' : 'bg-blue-600 text-white'} shadow-lg`
                    : `${isDarkMode ? 'bg-gray-800 text-gray-300 hover:bg-gray-700' : 'bg-white text-gray-600 hover:bg-gray-100'} border`
                    }`}
                >
                  <span>{tab.icon}</span>
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {activeView === 'overview' && (
                <>
                  <div className={`rounded-xl p-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
                    <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Shipments by Courier Partner
                    </h3>
                    <ResponsiveContainer width="100%" height={300}> Mode ? '#9CA3AF' : '#6B7280'} />
                        <YAxis stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="delivered" fill="#10B981" name="Delivered" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="pending" fill="#F59E0B" name="In Progress" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="issues" fill="#EF4444" name="Issues" radius={[4, 4, 0, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>

                  <div className={`rounded-xl p-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
                    <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Overall Status Distribution
                    </h3>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={statusBreakdown}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={120}
                          paddingAngle={2}
                          dataKey="value"
                        >
                          {statusBreakdown.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </>
              )}

              {activeView === 'performance' && (
                <>
                  <div className={`rounded-xl p-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
                    <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Delivery Rate by Partner
                    </h3>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart data={performanceData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#374151' : '#e5e7eb'} />
                        <XAxis dataKey="partner" stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
                        <YAxis stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar dataKey="deliveryRate" fill="#10B981" name="Delivery Rate %" radius={[4, 4, 0, 0]} />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>

                  <div className={`rounded-xl p-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
                    <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Partner Performance Metrics
                    </h3>
                    <div className="space-y-4">
                      {performanceData.map((partner, index) => (
                        <div key={partner.partner} className={`p-4 rounded-lg ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
                          <div className="flex justify-between items-center mb-2">
                            <span className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                              {partner.partner}
                            </span>
                            <span className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                              {partner.total} shipments
                            </span>
                          </div>
                          <div className="flex items-center space-x-4">
                            <div className="flex-1">
                              <div className="flex justify-between text-sm mb-1">
                                <span className="text-green-600">Delivery Rate</span>
                                <span className="text-green-600 font-medium">{partner.deliveryRate}%</span>
                              </div>
                              <div className="w-full bg-gray-300 dark:bg-gray-600 rounded-full h-2">
                                <div
                                  className="bg-green-500 h-2 rounded-full"
                                  style={{ width: `${partner.deliveryRate}%` }}
                                ></div>
                              </div>
                            </div>
                            <div className="flex-1">
                              <div className="flex justify-between text-sm mb-1">
                                <span className="text-red-600">Issue Rate</span>
                                <span className="text-red-600 font-medium">{partner.issueRate}%</span>
                              </div>
                              <div className="w-full bg-gray-300 dark:bg-gray-600 rounded-full h-2">
                                <div
                                  className="bg-red-500 h-2 rounded-full"
                                  style={{ width: `${partner.issueRate}%` }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {activeView === 'distribution' && (
                <>
                  <div className={`col-span-2 rounded-xl p-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
                    <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Shipment Status Distribution by Partner
                    </h3>
                    <ResponsiveContainer width="100%" height={400}>
                      <AreaChart
                        data={shipmentStats.map(stat => ({
                          partner: stat.partner,
                          Delivered: stat.delivered,
                          'In Transit': stat.inTransit,
                          'Out for Delivery': stat.ofd,
                          Manifested: stat.manifested,
                          Pending: stat.pending,
                          RTO: stat.rto,
                          Lost: stat.lost
                        }))}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? '#374151' : '#e5e7eb'} />
                        <XAxis dataKey="partner" stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
                        <YAxis stroke={isDarkMode ? '#9CA3AF' : '#6B7280'} />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend />
                        <Area type="monotone" dataKey="Delivered" stackId="1" stroke="#10B981" fill="#10B981" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="Out for Delivery" stackId="1" stroke="#8B5CF6" fill="#8B5CF6" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="In Transit" stackId="1" stroke="#F59E0B" fill="#F59E0B" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="Manifested" stackId="1" stroke="#3B82F6" fill="#3B82F6" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="Pending" stackId="1" stroke="#6B7280" fill="#6B7280" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="RTO" stackId="1" stroke="#EF4444" fill="#EF4444" fillOpacity={0.8} />
                        <Area type="monotone" dataKey="Lost" stackId="1" stroke="#374151" fill="#374151" fillOpacity={0.8} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </>
              )}
            </div>

            <div className={`mt-8 p-6 rounded-xl mb-6 ${isDarkMode ? 'dark:bg-darkmodeColor dark:text-white' : 'bg-white border-gray-200'} border shadow-lg`}>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div>
                  <p className={`text-2xl font-bold text-blue-600`}>
                    {shipmentStats.length}
                  </p>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Active Courier Partners</p>
                </div>
                <div>
                  <p className={`text-2xl font-bold text-green-600`}>
                    {((shipmentStats.reduce((sum, stat) => sum + stat.delivered, 0) / shipmentStats.reduce((sum, stat) => sum + stat.total, 0)) * 100).toFixed(1)}%
                  </p>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Overall Delivery Rate</p>
                </div>
                <div>
                  <p className={`text-2xl font-bold text-purple-600`}>
                    {shipmentStats.reduce((sum, stat) => sum + stat.total, 0).toLocaleString()}
                  </p>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Total Shipments Processed</p>
                </div>
              </div>
            </div> */}



            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">

              {/* Left Section - Chart */}
              <div className="col-span-2 md:col-span-3 bg-custom-gradient rounded-lg p-6 flex flex-col h-auto sm:min-h-80 shadow-lg">
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h3 className="text-white text-lg font-medium mb-2">Total Sales</h3>
                    <p className="text-white text-4xl font-bold">
                      ₹ {totaldata?.chartData?.quarterData?.total_sales}
                    </p>
                  </div>
                  <button className="text-white text-2xl font-bold hover:bg-white/10 rounded px-2">⋮</button>
                </div>

                <div className="flex-1 min-h-[220px] mt-4">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                      data={data}
                      margin={{ top: 5, right: 10, left: -20, bottom: 5 }}
                    >
                      <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="rgba(255,255,255,0.2)"
                        vertical={false}
                      />
                      <XAxis
                        dataKey="name"
                        stroke="rgba(255,255,255,0.7)"
                        tick={{ fill: "rgba(255,255,255,0.8)" }}
                      />
                      <YAxis
                        stroke="rgba(255,255,255,0.7)"
                        tick={{ fill: "rgba(255,255,255,0.8)" }}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "rgba(255,255,255,0.9)",
                          border: "none",
                          borderRadius: "8px",
                        }}
                      />
                      <Line
                        type="monotone"
                        dataKey="shipments"
                        stroke="#8884d8"
                        strokeWidth={1}
                        activeDot={{ r: 8 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* Right Section - Image Slider */}
              <div className="col-span-2 md:col-span-1 bg-gray-100 rounded-lg h-auto sm:min-h-80 shadow-lg overflow-hidden">
                <ImageOfferSlider />
              </div>
            </div>
            {/* Best Shipping Location */}
            <div className={`rounded-custom mt-5 mb-5  shadow-custom-light ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white dark:shadow-custom-dark" : "bg-white"}`}>
              <div className="flex justify-between items-center mb-4">
                <div className="flex items-center space-x-3">
                  <Package className={`w-6 h-6 ml-4 ${isDarkMode ? 'text-blue-300' : 'text-blue-600'}`} />
                  <p className="text-xl font-medium mt-4 mb-4 ">Recent Orders</p>
                </div>
                <a
                  href="/shipments/all"
                  className={`
            flex items-center space-x-2 
            text-blue-500 
            hover:text-blue-700 
            transition-colors 
            duration-2004
            mr-4
          `}
                >
                  <span>View All Orders</span>
                  <ArrowRight className="w-4 h-4 mr-4" />
                </a>
              </div>
            </div>
            <div>
              {(selectedRows.length > 0 || selectAll) && (
                <div className="mb-4">
                  <Button
                    onClick={handleDownload}
                    disabled={isloading}
                    sx={{
                      color: "black", // Ensures text is black
                      textTransform: "none", // Prevents automatic capitalization
                    }}
                    className="flex items-center gap-3  dark:text-white rounded-custom dark:shadow-custom-dark  shadow-custom-light  transition-all duration-200 font-medium"
                  >
                    {isloading ? (
                      <div className="flex items-center gap-2">
                        <Spinner className="w-4 h-4 animate-spin" />
                        <span>Downloading...</span>
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <FaDownload className="w-4 h-4" />
                        {/* <span>Download Selected ({selectAll ? currentItems.length : selectedRows.length})</span> */}
                        <span>
                          Download Selected (
                          {selectAll
                            ? currentItems.filter(item => item.partner).length
                            : selectedRows.filter(index => currentItems[index]?.partner).length}
                          )
                        </span>

                      </div>
                    )}
                  </Button>
                </div>
              )}
            </div>

            <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor  rounded-custom text-white" : "bg-white "}`}>
              {loading ? (
                <div className="flex justify-center items-center py-10">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="ml-2 text-xs text-blue-500">Loading orders...</span>
                </div>
              ) : (<div className='overflow-x-auto'>
                <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                  <thead className='bg-customPurple rounded-xl text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                    <tr>
                      <th className='p-2 text-left font-medium'>
                        <input
                          type="checkbox"
                          disabled
                          checked={selectAll}
                          onChange={handleSelectAll}
                          className="w-3 h-3 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </th>
                      <th className='p-2 text-left font-medium'>Order ID</th>
                      {role === 'admin' && <th className='p-2 text-left font-medium'>User ID</th>}
                      <th className='p-2 text-left font-medium'>Customer Info</th>
                      <th className='p-2 text-left font-medium'>Product Details</th>
                      {/* <th className='p-2 text-left font-medium'>Shipping Info</th> */}
                      <th className='p-2 text-left font-medium'>Payment</th>
                      <th className='p-2 text-left font-medium'>Status</th>
                      <th className='p-2 text-left font-medium'>Date</th>
                      <th className='p-2 text-left font-medium'>Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                    {currentItems.map((row, index) => (
                      <tr
                        key={index}
                        className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                          ? 'bg-white dark:bg-darkmodeColor'
                          : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                          }`}
                      >
                        <td className='p-2'>
                          <input
                            type="checkbox"
                            disabled={!row.partner}
                            checked={selectedRows.includes(index)}
                            onChange={() => handleRowSelect(index)}
                            className="w-3 h-3 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-1 dark:bg-gray-700 dark:border-gray-600"
                          />
                        </td>
                        <td
                          className={`relative group p-2 text-xs font-medium transition-colors ${!['pending', 'cancelled'].includes(row.status?.toLowerCase())
                            ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:text-blue-800 dark:hover:text-blue-300'
                            : 'text-gray-400 dark:text-gray-500 cursor-not-allowed'
                            }`}
                          onClick={() => {
                            if (!['pending', 'cancelled'].includes(row.status?.toLowerCase())) {
                              handleClick(row.order_id);
                            }
                          }}
                        >
                          {row.order_id || 'Unavailable'}

                          {!['pending', 'cancelled'].includes(row.status?.toLowerCase()) && (
                            <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                              📦 Track your shipment status here!
                              <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
                            </div>
                          )}
                        </td>

                        {role === 'admin' && (
                          <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                            {row.user_id}
                          </td>
                        )}

                        {/* Customer Info */}
                        <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>
                          <div className="font-semibold">{row.first_name} {row.last_name}</div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">{row.phone}</div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">{row.email}</div>
                        </td>

                        {/* Product Details */}
                        <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>
                          <div className="font-medium">{row.product_desc}</div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            Qty: {row.quantity} | Weight: {row.weight}g
                          </div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            {row.length}×{row.shipment_width}×{row.shipment_height}cm
                          </div>
                        </td>

                        {/* Shipping Info */}
                        {/* <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>
                          <div className="font-medium">{row.drop_city}, {row.drop_state}</div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            PIN: {row.drop_pin}
                          </div>
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            Type: {row.address_type}
                          </div>
                        </td> */}

                        {/* Payment Info */}
                        <td className='p-2 text-xs text-gray-700 dark:text-gray-300'>
                          <div className="font-semibold text-green-600 dark:text-green-400">
                            ₹{row.total_amount}
                          </div>
                          {row.payment_mode === 'cod' && (
                            <div className="text-[10px] text-orange-600 dark:text-orange-400">
                              COD: ₹{row.cod_amount}
                            </div>
                          )}
                          <div className="text-[10px] text-gray-500 dark:text-gray-400 uppercase">
                            {row.payment_mode}
                          </div>
                        </td>

                        {/* Status */}
                        <td className='p-2'>
                          {row.status?.length > 15 ? (
                            <div className="group relative">
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 cursor-pointer ${row.status === 'Manifested'
                                ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                                : row.status.toLowerCase() === 'in transit'
                                  ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                          : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                  ? 'bg-white animate-pulse'
                                  : row.status === 'In Transit'
                                    ? 'bg-white animate-bounce'
                                    : row.status.toLowerCase() === 'out for delivery'
                                      ? 'bg-white animate-bounce'
                                      : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                        ? 'bg-white'
                                        : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                          ? 'bg-white animate-pulse'
                                          : row.status.toLowerCase() === 'pending'
                                            ? 'bg-white animate-pulse'
                                            : 'bg-gray-400 dark:bg-gray-500'
                                  }`}></span>
                                {row.status.substring(0, 8)}...
                              </span>
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                {row.status}
                                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                              </div>
                            </div>
                          ) : (
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${row.status === 'Manifested'
                              ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40'
                              : row.status === 'In Transit'
                                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                : row.status.toLowerCase() === 'out for delivery'
                                  ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40'
                                  : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                    ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                    : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                      ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                      : row.status.toLowerCase() === 'pending'
                                        ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-lg shadow-yellow-500/25 hover:shadow-yellow-500/40'
                                        : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                              }`}>
                              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${row.status === 'Manifested'
                                ? 'bg-white animate-pulse'
                                : row.status === 'In Transit'
                                  ? 'bg-white animate-bounce'
                                  : row.status.toLowerCase() === 'out for delivery'
                                    ? 'bg-white animate-bounce'
                                    : row.status === 'Seller cancelled the order' || row.status === 'Cancel' || row.status === 'cancelled' || row.status === 'cancel'
                                      ? 'bg-white'
                                      : row.status.toLowerCase() === 'delivered' || row.status === 'Delivered' || row.status === 'Delivered to consignee'
                                        ? 'bg-white animate-pulse'
                                        : row.status.toLowerCase() === 'pending'
                                          ? 'bg-white animate-pulse'
                                          : 'bg-gray-400 dark:bg-gray-500'
                                }`}></span>
                              {row.status}
                            </span>
                          )}
                        </td>

                        {/* Date */}
                        <td className='p-2 text-xs text-gray-600 dark:text-gray-400 font-mono'>
                          {new Date(row.created_at).toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          })}
                          <div className="text-[10px] text-gray-500 dark:text-gray-400">
                            {new Date(row.created_at).toLocaleTimeString('en-IN', {
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </td>

                        {/* Actions */}
                        <td className='p-2'>
                          <div className='flex items-center gap-1'>
                            <Button
                              onClick={() => handleViewClick(row)}
                              variant="contained"
                              color="primary"
                              size="small"
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                              style={{
                                backgroundColor: '#3b82f6',
                                '&:hover': { backgroundColor: '#2563eb' }
                              }}
                            >
                              <IoMdEye className="text-xs" />
                            </Button>

                            <Button
                              onClick={() => handleShipNow(row)}
                              variant="contained"
                              size="small"
                              disabled={loadingOrderIdShip === row.order_id || row.status?.toLowerCase() !== "pending"}
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow group relative"
                              style={{
                                backgroundColor: '#10b981',
                                '&:hover': { backgroundColor: '#059669' }
                              }}
                            >
                              {loadingOrderIdShip === row.order_id ? (
                                <span className="animate-spin text-xs inline-block">⟳</span>
                              ) : (
                                <span className="text-xs">🚚</span>
                              )}
                              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                Ship Now
                                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-gray-900 dark:border-t-gray-800"></div>
                              </div>
                            </Button>

                            <Button
                              onClick={() => handleCancelOrder(row.order_id)}
                              variant="contained"
                              color="error"
                              size="small"
                              disabled={loadingOrderIdCancleOrder === row.order_id || row.status?.toLowerCase() !== "pending"}
                              className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                              style={{
                                backgroundColor: '#ef4444',
                                '&:hover': { backgroundColor: '#dc2626' }
                              }}
                            >
                              {loadingOrderIdCancleOrder === row.order_id ? (
                                <span className="animate-spin text-xs">⏳</span>
                              ) : (
                                <RxCross2 className="text-xs" />
                              )}
                            </Button>

                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ViewAllShipment isopen={isPopupOpen} onClose={handleClose} shipment={selectedShipment} wareHouseList={wareHouseList} />
      <ViewRateForwardShipment isopen={isPopupOpenForShip} onClose={handleCloseForShip} data={selectedShipment} />
    </div>



    //new dashboard 
    // <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-gradient-to-br from-[#010E4E] to-[#02103A]' : 'bg-gradient-to-br from-[#f8fafc] to-[#e2e8f0]'}`}>
    //   <div className="z-10">
    //     <NavBar />
    //   </div>
    //   {
    //     profile_flag === "0" && role != "admin" && (
    //       <div className="bg-red-50 border-l-4 border-red-500 p-2 mx-4 mt-2 rounded-md shadow-sm">
    //         <div className="flex items-center">
    //           <svg className="h-5 w-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
    //             <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
    //           </svg>
    //           <p className="text-red-600 font-medium text-sm">Your KYC is pending. Please contact the support team at support@pickupxpress.com</p>
    //         </div>
    //       </div>
    //     )
    //   }
    //   <div className="flex flex-1 overflow-hidden">
    //     {isToggleSidebar && (
    //       <div className={`fixed z-20 h-full w-64 md:relative duration-300 ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 shadow-lg`}
    //         style={
    //           window.innerWidth < 768
    //             ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
    //             : {}
    //         }>
    //         <Sidebar />
    //       </div>
    //     )}
    //     <div
    //       className={`flex-1 overflow-auto transition-all duration-300 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:text-white" : ""}`}>

    //       <div className="">


    //         <div className="space-y-6">
    //           <div className={`rounded-xl overflow-hidden shadow-lg  dark:shadow-custom-dark m-2 ${isDarkMode ? 'bg-darkmodeColor backdrop-blur' : 'bg-white'}`}>
    //             <div className={`${isDarkMode ? 'bg-darkmodeColor' : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50'} p-6 rounded-xl transition-all duration-300 relative overflow-hidden`}>
    //               <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
    //                 <div className={`absolute top-10 left-10 w-32 h-32 rounded-full bg-pink-500 opacity-10 mix-blend-multiply blur-3xl`}></div>
    //                 <div className={`absolute bottom-10 right-10 w-64 h-64 rounded-full bg-blue-500 opacity-10 mix-blend-multiply blur-3xl`}></div>
    //                 <div className={`absolute top-40 right-20 w-48 h-48 rounded-full bg-purple-500 opacity-10 mix-blend-multiply blur-3xl`}></div>
    //                 <div className={`absolute bottom-40 left-40 w-48 h-48 rounded-full bg-yellow-500 opacity-10 mix-blend-multiply blur-3xl`}></div>
    //               </div>

    //               <div className="relative z-10">
    //                 <div className={`rounded-2xl overflow-hidden  dark:shadow-custom-dark  shadow-2xl mb-8 ${isDarkMode ? 'bg-darkmodeColor' : 'bg-white backdrop-blur-lg bg-opacity-70'}`}>
    //                   <div className="relative px-8 py-7">
    //                     <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500"></div>
    //                     {/* Metrics Grid with elevated colorful cards */}
    //                     <div className="grid grid-cols-1 md:grid-cols-4 gap-6 ">
    //                       {/* Total Orders */}
    //                       <div className="relative rounded-2xl dark:shadow-custom-dark overflow-hidden transition-all duration-300 transform hover:scale-105 group">
    //                         {/* Card background with pulsing gradient */}
    //                         <div className={`absolute inset-0 ${isDarkMode
    //                           ? 'bg-darkmodeColor'
    //                           : 'bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600'} z-0`}>
    //                         </div>

    //                         {/* Card content */}
    //                         <div className="relative  z-10 p-5 h-full">
    //                           <div className="flex items-start justify-between">
    //                             <div>
    //                               <p className="text-sm font-extrabold text-white/80">Total Orders</p>
    //                               <p className="text-3xl font-extrabold mt-2 text-white">
    //                                 {totaldata?.data?.total_order || "0"}
    //                               </p>
    //                             </div>
    //                             <div className="h-14 w-14 rounded-xl flex items-center justify-center bg-white/20 backdrop-blur-lg shadow-lg border border-white/30 group-hover:scale-110 transition-all duration-300">
    //                               <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
    //                               </svg>
    //                             </div>
    //                           </div>
    //                           <div className="text-xs mt-4 text-white/80">
    //                             All orders this month
    //                           </div>

    //                           {/* Decorative elements */}
    //                           <div className="absolute -bottom-8 -right-8 h-24 w-24 rounded-full bg-white/10"></div>
    //                           <div className="absolute top-2 left-1/2 h-1 w-1/2 rounded-full bg-white/20 transform -translate-x-1/2"></div>
    //                         </div>
    //                       </div>

    //                       {/* Total Delivered */}
    //                       <div className="relative rounded-2xl dark:shadow-custom-dark overflow-hidden transition-all duration-300 transform hover:scale-105 group">
    //                         {/* Card background */}
    //                         <div className={`absolute inset-0 ${isDarkMode
    //                           ? 'bg-gradient-to-br from-green-900 via-green-800 to-emerald-900'
    //                           : 'bg-gradient-to-br from-green-500 via-green-600 to-emerald-600'} z-0`}>
    //                         </div>

    //                         {/* Card content */}
    //                         <div className="relative z-10 p-5 h-full">
    //                           <div className="flex items-start justify-between">
    //                             <div>
    //                               <p className="text-sm font-extrabold text-white/80">Delivered</p>
    //                               <p className="text-3xl font-extrabold mt-2 text-white">
    //                                 {totaldata?.data?.total_delivered || "0"}
    //                               </p>
    //                             </div>
    //                             <div className="h-14 w-14 rounded-xl flex items-center justify-center bg-white/20 backdrop-blur-lg shadow-lg border border-white/30 group-hover:scale-110 transition-all duration-300">
    //                               <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    //                               </svg>
    //                             </div>
    //                           </div>
    //                           <div className="text-xs mt-4 text-white/80">
    //                             Successfully delivered
    //                           </div>

    //                           {/* Decorative elements */}
    //                           <div className="absolute -bottom-8 -right-8 h-24 w-24 rounded-full bg-white/10"></div>
    //                           <div className="absolute top-2 left-1/2 h-1 w-1/2 rounded-full bg-white/20 transform -translate-x-1/2"></div>
    //                         </div>
    //                       </div>

    //                       {/* COD Orders */}
    //                       <div className="relative rounded-2xl overflow-hidden dark:shadow-custom-dark transition-all duration-300 transform hover:scale-105 group">
    //                         {/* Card background */}
    //                         <div className={`absolute inset-0 ${isDarkMode
    //                           ? 'bg-gradient-to-br from-amber-900 via-amber-800 to-yellow-900'
    //                           : 'bg-gradient-to-br from-amber-500 via-amber-600 to-yellow-600'} z-0`}>
    //                         </div>

    //                         {/* Card content */}
    //                         <div className="relative z-10 p-5 h-full">
    //                           <div className="flex items-start justify-between">
    //                             <div>
    //                               <p className="text-sm font-extrabold text-white/80">COD Orders</p>
    //                               <p className="text-3xl font-extrabold mt-2 text-white">
    //                                 {totaldata?.data?.total_cod || "0"}
    //                               </p>
    //                             </div>
    //                             <div className="h-14 w-14 rounded-xl flex items-center justify-center bg-white/20 backdrop-blur-lg shadow-lg border border-white/30 group-hover:scale-110 transition-all duration-300">
    //                               <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path>
    //                               </svg>
    //                             </div>
    //                           </div>
    //                           <div className="text-xs mt-4 text-white/80">
    //                             Cash on delivery
    //                           </div>

    //                           {/* Decorative elements */}
    //                           <div className="absolute -bottom-8 -right-8 h-24 w-24 rounded-full bg-white/10"></div>
    //                           <div className="absolute top-2 left-1/2 h-1 w-1/2 rounded-full bg-white/20 transform -translate-x-1/2"></div>
    //                         </div>
    //                       </div>

    //                       {/* Prepaid Orders */}
    //                       <div className="relative rounded-2xl dark:shadow-custom-dark overflow-hidden transition-all duration-300 transform hover:scale-105 group">
    //                         {/* Card background */}
    //                         <div className={`absolute inset-0 ${isDarkMode
    //                           ? 'bg-darkmodeColor'
    //                           : 'bg-gradient-to-br from-purple-500 via-purple-600 to-fuchsia-600'} z-0`}>
    //                         </div>

    //                         {/* Card content */}
    //                         <div className="relative z-10 p-5 h-full">
    //                           <div className="flex items-start justify-between">
    //                             <div>
    //                               <p className="text-sm font-extrabold text-white/80">Prepaid Orders</p>
    //                               <p className="text-3xl font-extrabold mt-2 text-white">
    //                                 {totaldata?.data?.total_prepaid || "0"}
    //                               </p>
    //                             </div>
    //                             <div className="h-14 w-14 rounded-xl flex items-center justify-center bg-white/20 backdrop-blur-lg shadow-lg border border-white/30 group-hover:scale-110 transition-all duration-300">
    //                               <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
    //                               </svg>
    //                             </div>
    //                           </div>
    //                           <div className="text-xs mt-4 text-white/80">
    //                             Pre-payment completed
    //                           </div>

    //                           {/* Decorative elements */}
    //                           <div className="absolute -bottom-8 -right-8 h-24 w-24 rounded-full bg-white/10"></div>
    //                           <div className="absolute top-2 left-1/2 h-1 w-1/2 rounded-full bg-white/20 transform -translate-x-1/2"></div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //                 <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
    //                   {/* Partners Orders */}
    //                   <div className={`rounded-lg overflow-hidden transition-all duration-300 transform hover:-translate-y-1 shadow-md dark:shadow-custom-dark ${isDarkMode
    //                     ? 'bg-darkmodeColor'
    //                     : 'bg-white/70 backdrop-blur-lg border border-white/50 shadow-md'
    //                     } group`}>
    //                     <div className="p-2 relative">
    //                       {/* Decorative color accent */}
    //                       <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-indigo-500 to-blue-500"></div>

    //                       <div className="flex items-center justify-between mb-1">
    //                         <h3 className={`text-sm font-bold flex items-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                           <span>Partners Orders</span>
    //                         </h3>
    //                         <div className="h-7 w-7 rounded-full flex items-center justify-center bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-sm transform group-hover:rotate-12 transition-all duration-300">
    //                           <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
    //                           </svg>
    //                         </div>
    //                       </div>
    //                       <div className="flex items-end space-x-2">
    //                         <div>
    //                           <p className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                             {totaldata?.data?.total_shopify || "0"}
    //                           </p>
    //                           <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
    //                             Total partner orders in {totaldata?.data?.month}
    //                           </p>
    //                         </div>
    //                       </div>
    //                       <div className="mt-1.5 h-1 w-full rounded-full bg-gray-200/50 overflow-hidden">
    //                         <div className="h-1 rounded-full bg-gradient-to-r from-indigo-500 to-blue-500" style={{ width: '65%' }}>
    //                           <div className="w-full h-full bg-gradient-to-r from-transparent to-white/20 animate-pulse"></div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>

    //                   {/* NDR */}
    //                   <div className={`rounded-lg overflow-hidden transition-all cursor-pointer duration-300 transform hover:-translate-y-1 shadow-md dark:shadow-custom-dark ${isDarkMode
    //                     ? 'bg-darkmodeColor'
    //                     : 'bg-white/70 backdrop-blur-lg border border-white/50 shadow-md'
    //                     } group`}
    //                      onClick={handleNavigateToNDR}>
    //                     <div className="p-2 relative">
    //                       {/* Decorative color accent */}
    //                       <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-red-500 to-pink-500"></div>

    //                       <div className="flex items-center justify-between mb-1">
    //                         <h3 className={`text-sm font-bold flex items-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                           <span>NDR</span>
    //                         </h3>
    //                         <div className="h-7 w-7 rounded-full flex items-center justify-center bg-gradient-to-br from-red-500 to-pink-600 text-white shadow-sm transform group-hover:rotate-12 transition-all duration-300">
    //                           <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
    //                           </svg>
    //                         </div>
    //                       </div>
    //                       <div className="flex items-end justify-between">
    //                         <div>
    //                           <p className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                             {totaldata?.data?.total_ndr || "0"}
    //                           </p>
    //                           <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
    //                             Non-delivered returns in {totaldata?.data?.month}
    //                           </p>
    //                         </div>
    //                         <div className="text-2xs px-2 py-1 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-sm flex items-center transform translate-y-0 group-hover:translate-y-0 transition-all duration-300">
    //                           <span>View</span>
    //                           <svg className="h-2.5 w-2.5 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
    //                           </svg>
    //                         </div>
    //                       </div>
    //                       <div className="mt-1.5 h-1 w-full rounded-full bg-gray-200/50 overflow-hidden">
    //                         <div className="h-1 rounded-full bg-gradient-to-r from-red-500 to-pink-500" style={{ width: '20%' }}>
    //                           <div className="w-full h-full bg-gradient-to-r from-transparent to-white/20 animate-pulse"></div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>

    //                   {/* COD Remittance */}
    //                   <div className={`rounded-lg overflow-hidden transition-all cursor-pointer duration-300 transform hover:-translate-y-1 shadow-md dark:shadow-custom-dark ${isDarkMode
    //                     ? 'bg-darkmodeColor'
    //                     : 'bg-white/70 backdrop-blur-lg border border-white/50 shadow-md'
    //                     } group`}>
    //                     <div className="p-2 relative">
    //                       {/* Decorative color accent */}
    //                       <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-green-500 to-emerald-500"></div>

    //                       <div className="flex items-center justify-between mb-1">
    //                         <h3 className={`text-sm font-bold flex items-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                           <span>COD Remittance</span>
    //                         </h3>
    //                         <div className="h-7 w-7 rounded-full flex items-center justify-center bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-sm transform group-hover:rotate-12 transition-all duration-300">
    //                           <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    //                           </svg>
    //                         </div>
    //                       </div>
    //                       <div className="flex items-end justify-between">
    //                         <div>
    //                           <p className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
    //                             ₹{totaldata?.data?.total_cod_remittance || "0"}
    //                           </p>
    //                           <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
    //                             Total remittance in {totaldata?.data?.month}
    //                           </p>
    //                         </div>
    //                         <div className="text-2xs px-2 py-1 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-sm flex items-center transform translate-y-0 group-hover:translate-y-0 transition-all duration-300">
    //                           <span>View</span>
    //                           <svg className="h-2.5 w-2.5 ml-1 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
    //                           </svg>
    //                         </div>
    //                       </div>
    //                       <div className="mt-1.5 h-1 w-full rounded-full bg-gray-200/50 overflow-hidden">
    //                         <div className="h-1 rounded-full bg-gradient-to-r from-green-500 to-emerald-500" style={{ width: '75%' }}>
    //                           <div className="w-full h-full bg-gradient-to-r from-transparent to-white/20 animate-pulse"></div>
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>

    //           {/* Offer Slider */}
    //           <div className={`rounded-xl dark:shadow-custom-dark m-2 overflow-hidden ${isDarkMode ? 'bg-darkmodeColor' : 'bg-white'} shadow-lg p-1`}>
    //             <OffersSlider />
    //           </div>

    //           <div className="bg-custom-gradient rounded-lg p-4 dark:shadow-custom-dark m-2 transform transition-transform">
    //             <div className="flex justify-between items-start">
    //               <div>
    //                 <p className="text-white text-lg font-bold">Total Sales</p>
    //                 <p className="text-white text-4xl font-bold">₹ {totaldata?.chartData?.quarterData?.total_sales}</p>
    //                 {/* <p className="text-white text-sm">₹ 00 In last month</p> */}
    //               </div>
    //               <span className="text-white text-2xl">⋮</span>
    //             </div>
    //             <div className="mt-4 h-48">
    //               <ResponsiveContainer width="100%" height="100%">
    //                 <LineChart data={data}>
    //                   <CartesianGrid strokeDasharray="3 3" />
    //                   <XAxis dataKey="name" />
    //                   <YAxis />
    //                   <Tooltip />
    //                   <Line type="monotone" dataKey="shipments" stroke="#8884d8" activeDot={{ r: 8 }} />
    //                   <Line type="monotone" dataKey="boxes" stroke="#82ca9d" />
    //                 </LineChart>
    //               </ResponsiveContainer>
    //             </div>
    //           </div>

    //           {/* Recent Orders Section */}
    //           <div className={`rounded-xl overflow-hidden dark:shadow-custom-dark m-2 ${isDarkMode ? 'bg-darkmodeColor' : 'bg-white'} shadow-lg`}>
    //             <div className="p-6">
    //               <div className="flex justify-between items-center mb-6">
    //                 <div className="flex items-center">
    //                   <Package className={`w-5 h-5 mr-2 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
    //                   <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Recent Orders</h3>
    //                 </div>
    //                 <a
    //                   href="/shipments/all"
    //                   className={`flex items-center space-x-1 text-sm font-medium px-3 py-1 rounded-lg ${isDarkMode ? 'bg-blue-900/30 text-blue-300 hover:bg-blue-900/50' : 'bg-blue-50 text-blue-700 hover:bg-blue-100'} transition-colors`}
    //                 >
    //                   <span>View All</span>
    //                   <ArrowRight className="w-4 h-4" />
    //                 </a>
    //               </div>

    //               {/* Download Selected Button */}
    //               {(selectedRows.length > 0 || selectAll) && (
    //                 <div className="mb-4">
    //                   <Button
    //                     onClick={handleDownload}
    //                     disabled={isloading}
    //                     className={`py-2 px-4 rounded-lg flex items-center gap-2 ${isDarkMode
    //                       ? 'bg-blue-900/40 text-blue-300 hover:bg-blue-900/60'
    //                       : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
    //                       } transition-all duration-200 font-medium border-none shadow-none`}
    //                   >
    //                     {isloading ? (
    //                       <div className="flex items-center gap-2">
    //                         <Spinner className="w-4 h-4 animate-spin" />
    //                         <span>Downloading...</span>
    //                       </div>
    //                     ) : (
    //                       <div className="flex items-center gap-2">
    //                         <FaDownload className="w-4 h-4" />
    //                         <span>Download Selected ({selectAll ? currentItems.length : selectedRows.length})</span>
    //                       </div>
    //                     )}
    //                   </Button>
    //                 </div>
    //               )}

    //               {/* Table */}
    //               <div className='overflow-x-auto '>
    //                 <table className='min-w-full divide-y divide-gray-300 dark:divide-gray-700'>
    //                   <thead className='bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500'>

    //                     <tr>
    //                       <th className='p-3 text-left'>
    //                         <input
    //                           type="checkbox"
    //                           checked={selectAll}
    //                           onChange={handleSelectAll}
    //                           className={`rounded border-gray-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : ''}`}
    //                         />
    //                       </th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>OID</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>UID</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Partner</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Customer</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>WayBill</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Mode</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Status</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Charges</th>
    //                       <th className={`p-3 text-left text-xs font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-800'} uppercase tracking-wider`}>Action</th>
    //                     </tr>
    //                   </thead>
    //                   <tbody className={`${isDarkMode ? 'divide-y divide-gray-700' : 'divide-y divide-gray-200'}`}>
    //                     {currentItems.map((shipment, index) => (
    //                       <tr key={index} className={`${isDarkMode ? 'hover:bg-gray-800/30' : 'hover:bg-gray-50'} transition-colors`}>
    //                         <td className='p-3'>
    //                           <input
    //                             type="checkbox"
    //                             checked={selectedRows.includes(index)}
    //                             onChange={() => handleRowSelect(index)}
    //                             className={`rounded border-gray-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : ''}`}
    //                           />
    //                         </td>
    //                         {/* <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.order_id}</td> */}
    //                         <td
    //                           className="relative group p-2 text-sm text-blue-600 cursor-pointer hover:underline"
    //                           onClick={() => handleClick(shipment.order_id)}
    //                         >
    //                           {shipment.order_id}

    //                           <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 text-white text-xs rounded px-3 py-1 shadow-lg z-10 whitespace-nowrap">
    //                             📦 Track your shipment status here!
    //                           </div>
    //                         </td>

    //                         <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.user_id}</td>
    //                         <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.partner}</td>
    //                         <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.first_name + shipment.last_name}</td>
    //                         <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.waybill}</td>
    //                         <td className={`p-3 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{shipment.shipping_mode}</td>
    //                         <td className={`p-3 text-sm`}>
    //                           <span className={`px-2 py-1 text-xs rounded-full ${shipment.status?.toLowerCase() === 'delivered'
    //                             ? isDarkMode ? 'bg-green-900/30 text-green-300' : 'bg-green-100 text-green-800'
    //                             : shipment.status?.toLowerCase() === 'cancel'
    //                               ? isDarkMode ? 'bg-red-900/30 text-red-300' : 'bg-red-100 text-red-800'
    //                               : isDarkMode ? 'bg-blue-900/30 text-blue-300' : 'bg-blue-100 text-blue-800'
    //                             }`}>
    //                             {shipment.status}
    //                           </span>
    //                         </td>
    //                         <td className={`p-3 text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>₹{shipment.debit_amount || 'N/A'}</td>
    //                         <td className='p-3'>
    //                           <div className='flex space-x-2'>
    //                             <Button
    //                               variant="contained"
    //                               size="small"
    //                               onClick={() => handleViewClick(shipment)}
    //                               className={`min-w-0 p-1 ${isDarkMode
    //                                 ? 'bg-blue-900/40 text-blue-300 hover:bg-blue-900/60'
    //                                 : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
    //                                 }`}
    //                             >
    //                               <IoMdEye className="h-4 w-4" />
    //                             </Button>
    //                             <Button
    //                               onClick={() => handlePrintLabel(shipment.order_id)}
    //                               variant="contained"
    //                               size="small"
    //                               disabled={loadingOrderId === shipment.order_id}
    //                               className={`min-w-0 p-1 ${isDarkMode
    //                                 ? 'bg-purple-900/40 text-purple-300 hover:bg-purple-900/60'
    //                                 : 'bg-purple-50 text-purple-700 hover:bg-purple-100'
    //                                 }`}
    //                             >
    //                               {loadingOrderId === shipment.order_id ? (
    //                                 <span className="animate-spin">
    //                                   <FcPrint className="h-4 w-4" />
    //                                 </span>
    //                               ) : (
    //                                 <FcPrint className="h-4 w-4" />
    //                               )}
    //                             </Button>
    //                             <Button
    //                               // onClick={() => handleCancelOrder(shipment.order_id)}
    //                               variant="contained"
    //                               color="error"
    //                               disabled={loadingOrderIdCancleOrder === shipment.order_id && shipment.status?.toLowerCase() !== 'cancel'}
    //                             >
    //                               {loadingOrderIdCancleOrder === shipment.order_id ? (
    //                                 <span className="animate-spin">⏳</span>
    //                               ) : (
    //                                 <RxCross2 />
    //                               )}
    //                             </Button>
    //                           </div>
    //                         </td>
    //                       </tr>
    //                     ))}
    //                   </tbody>
    //                 </table>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <ViewAllShipment isopen={isPopupOpen} onClose={handleClose} shipment={selectedShipment} />
    // </div>
  );
};


// const DashBoard = () => {
//   const {isToggleSidebar, isDarkMode} = useMyContext();
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [selectedShipment, setSelectedShipment] = useState();
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [shipments, setShipments] = useState([]);
//   const [error, setError] = useState(null);
//   const [filteredShipmemt, setFilteredShipment] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [totaldata, setTotalData] = useState();
//   const navigate = useNavigate();
//   const {logout} = useAuth()
//   const {profile_flag, setProfile_flag} = useMyContext()
//   const [isloading, isSetLoading] = useState(false);
//   const [loadingOrderId, setLoadingOrderId] = useState(null);
//   const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);


//   const token = localStorage.getItem('token');
//   const cusid = localStorage.getItem('cus_id');
//   const role = localStorage.getItem('role');
//   const profile_Flag = localStorage.getItem('profile_flag');

//   const dashboardUrl = Base_Url + dashboard;
//   const cancleOrderApi = Base_Url + cancleOrder;

//   useEffect(() => {
//     fetchOrderData();
//     totalData();
//     fetchUserData()
//   }, []);

//   const fetchUserData = async () => {
//     const url = Base_Url + userdata;
//     if (cusid) {
//       try {
//         const response = await fetch(url + "/" + cusid, {
//           method: 'GET',
//           headers: {
//             'token': token,
//             'cus_id': cusid,
//             'Content-Type': 'application/json',
//           },
//         });
//         const result = await response.json();
//         setProfile_flag(result.data.profile_flag)

//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("user");
//     navigate('/login')
//     logout()
//     localStorage.removeItem('cus_id')
//     localStorage.removeItem('token')
//   }

//   const fetchOrderData = async () => {
//     const url = Base_Url + forwardorderlistall;
//     try {
//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           token,
//           cus_id: cusid,
//           'Content-Type': 'application/json',
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setShipments(data.data || []);
//         setFilteredShipment(data.data.slice(0, 9));
//       }
//       else if (data.status === "FAIL" && data.message === "Unauthorized access - Invalid token") {
//         toast.error(data.message + " Please Login Again");
//         handleLogout();
//       }
//       else {
//         setError('Error fetching data: ' + data.message);
//       }
//     } catch (error) {
//       setError('API error: ' + error.message);
//     } finally {

//     }
//   };
//   const totalData = async () => {
//     try {
//       const response = await fetch(dashboardUrl, {
//         method: 'GET',
//         headers: {
//           token: token,
//           cus_id: cusid,
//           'Content-Type': 'application/json',
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setTotalData(data || []);
//         // setFilteredShipment(data.data.slice(0,9));
//       } else {
//         setError('Error fetching data: ' + data.message);
//       }
//     } catch (error) {
//       setError('API error: ' + error.message);
//     } finally {

//     }
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const filterShipment = shipments;
//   const currentItems = filterShipment.slice(indexOfFirstItem, indexOfLastItem);
//   // const total = shipments.reduce((sum, shipment) => sum + parseFloat(shipment.debit_amount), 0);

//   const handleViewClick = (shipment) => {
//     setSelectedShipment(shipment)
//     setIsPopupOpen(true);
//   };

//   const handleClose = () => {
//     setIsPopupOpen(false);
//   };
//   const data = totaldata?.chartData?.monthlyData;

//   const handleSelectAll = (e) => {
//     if (e.target.checked) {
//       setSelectedRows([...Array(shipments.length).keys()]);
//     } else {
//       setSelectedRows([]);
//     }
//     setSelectAll(e.target.checked);
//   };


//   const handleRowSelect = (index) => {
//     setSelectedRows((prev) => {
//       const isSelected = prev.includes(index);
//       if (isSelected) {
//         return prev.filter(i => i !== index);
//       } else {
//         return [...prev, index];
//       }
//     });
//   };

//   const handlePrintLabel = async (orderId) => {
//     setLoadingOrderId(orderId);
//     try {
//       const response = await fetch(Base_Url + shipmentlabel, {
//         method: 'POST',
//         headers: {
//           token,
//           cus_id: cusid,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({order_id: orderId }),
//       });
//       const data = await response.json();
//       if (data.status === "SUCCESS") {
//         const printUrl = data?.DownloadLink;
//         if (printUrl) {
//           const printLabel = Base_Url + printUrl
//           window.open(printLabel, '_blank');
//         }
//         setLoadingOrderId(null);
//       }
//       else {
//         toast.error(data.message || "url is not found please try again !");
//         setLoadingOrderId(null);
//       }
//     } catch (error) {
//       setError('API error: ' + error.message);
//       setLoadingOrderId(null);
//     }
//   };

//   const getSelectedOrderIds = () => {
//     if (selectAll) {
//       // If all are selected, return all order IDs
//       return currentItems.map(shipment => shipment.order_id);
//     } else {
//       // For individual selections, map correctly to the displayed items
//       return selectedRows.map(index => {
//         // Make sure we're accessing the correct item in currentItems
//         return currentItems[index].order_id;
//       });
//     }
//   };

//   const totadldata = {
//     data: {
//       total_order: 256,
//       total_delivered: 198,
//       total_cod: 145,
//       total_prepaid: 111,
//       total_shopify: 0,
//       total_ndr: 28,
//       total_cod_remittance: 125000,
//       month: "Apr"
//     }
//   };

//   const handleDownload = async () => {
//     const selectedOrderIds = getSelectedOrderIds();
//     const urlForDownloadBulkLabel = Base_Url + bulkshipmentlabel;
//     const payload = {
//       order_ids: selectedOrderIds
//     };

//     const headers = {
//       token: token,
//       cus_id: cusid,
//       'Content-Type': 'application/json',
//     };
//     isSetLoading(true);
//     try {
//       const response = await fetch(urlForDownloadBulkLabel, {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify(payload),
//       });
//       const data = await response.json();
//       if (data.status === "SUCCESS") {
//         const pdf = data.DownloadLink;
//         const downloadPdf = Url_For_View_Document + pdf;
//         if (downloadPdf) {
//           window.open(downloadPdf, "_blank")
//         }
//         isSetLoading(false);
//       }
//       else {
//         toast.error(data.message);
//         isSetLoading(false);
//       }
//     } catch (error) {
//       console.error('Error downloading orders:', error);
//       isSetLoading(false);
//     }
//   };

//   // Navigation handlers for new cards
//   const handleNavigateToNDR = () => {
//     navigate('/ndr');
//   };

//   const handleNavigateToCODRemittance = () => {
//     navigate('/cod-remittance');
//   };

//   return (
//     <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
//       <div className="z-10">
//         <NavBar />
//       </div>
//       {
//         profile_flag === "0" && role != "admin" ? <marquee className=" text-red-500 font-medium "> Your Kyc Is Pending Please Contact To The Support Team on support@pickupxpress.com</marquee> : ""
//       }
//       <div className="flex flex-1 overflow-hidden">
//         {isToggleSidebar && (
//           <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
//             style={
//               window.innerWidth < 768
//                 ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
//                 : {}
//             }>
//             <Sidebar />
//           </div>
//         )}
//         <div
//           className={`flex-1 overflow-auto transition-all duration-300 ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-darkmodeColor dark:text-gray-800" : "bg-white"}`}>
//           {/* DashBoard Content */}
//           <div className="p-4 md:p-6 min-h-screen transition-all duration-300 rounded-custom">
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//               {/* Card 1 */}
//               <div className="bg-gradient-to-r from-[#06bb6d] to-[#036a3e] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102">
//                 <p className="text-white text-lg font-sans">Total Orders</p>
//                 <p className="text-white text-2xl font-medium">{totaldata?.data?.total_order}</p>
//                 <p className="text-white text-sm font-sans">Total Order {totaldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <ShoppingCart className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* Card 2 */}
//               <div className="bg-gradient-to-r from-[#7f04a6] to-[#62059e] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102">
//                 <p className="text-white text-lg font-sans">Total Delivered</p>
//                 <p className="text-white text-2xl font-medium">{totaldata?.data?.total_delivered}</p>
//                 <p className="text-white text-sm font-sans">Total Delivered Order {totaldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <Package className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* Card 3 */}
//               <div className="bg-gradient-to-r from-[#a6042b] to-[#e81581] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102">
//                 <p className="text-white text-lg font-sans">COD Orders</p>
//                 <p className="text-white text-2xl font-medium">{totaldata?.data?.total_cod}</p>
//                 <p className="text-white text-sm font-sans"> Total COD Order {totaldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <FaRupeeSign className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* Card 4 */}
//               <div className="bg-gradient-to-r from-[#e85a15] to-[#a63904] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102">
//                 <p className="text-white text-lg font-sans">Prepaid Orders</p>
//                 <p className="text-white text-2xl font-medium">{totaldata?.data?.total_prepaid}</p>
//                 <p className="text-white text-sm font-sans">Total Prepaid Order {totaldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <BsFillCreditCard2FrontFill className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* Card 5 - Partners Orders */}
//               <div className="bg-gradient-to-r from-[#0072bb] to-[#004a76] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102">
//                 <p className="text-white text-lg font-sans">Partners Orders</p>
//                 <p className="text-white text-2xl font-medium">{totadldata?.data?.total_shopify}</p>
//                 <p className="text-white text-sm font-sans">Total Partners Order {totadldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <FaJediOrder className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* NEW CARD: NDR */}
//               <div 
//                 onClick={handleNavigateToNDR}
//                 className="bg-gradient-to-r from-[#FF5722] to-[#D84315] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102 cursor-pointer"
//               >
//                 <p className="text-white text-lg font-sans">NDR</p>
//                 <p className="text-white text-2xl font-medium">{totadldata?.data?.total_ndr}</p>
//                 <p className="text-white text-sm font-sans">Total Non-Delivered {totadldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <FaExclamationTriangle className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>

//               {/* NEW CARD: COD Remittance */}
//               <div 
//                 onClick={handleNavigateToCODRemittance}
//                 className="bg-gradient-to-r from-[#00796B] to-[#004D40] rounded-lg p-4 shadow-md transform transition-transform hover:scale-102 cursor-pointer"
//               >
//                 <p className="text-white text-lg font-sans">COD Remittance</p>
//                 <p className="text-white text-2xl font-medium">₹{totadldata?.data?.total_cod_remittance}</p>
//                 <p className="text-white text-sm font-sans">Total Remittance {totadldata?.data?.month}</p>
//                 <div className="flex justify-between items-center mt-2">
//                   <FaMoneyBillWave className="text-white h-6 w-6" />
//                   <span className="text-white text-2xl">⋮</span>
//                 </div>
//               </div>
//             </div>

//             <OffersSlider/>

//             {/* Card 5 - Total Sales */}
//             <div className="bg-custom-gradient rounded-lg p-4 transform transition-transform">
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="text-white text-lg font-bold">Total Sales</p>
//                   <p className="text-white text-4xl font-bold">₹ {totaldata?.chartData?.quarterData?.total_sales}</p>
//                   {/* <p className="text-white text-sm">₹ 00 In last month</p> */}
//                 </div>
//                 <span className="text-white text-2xl">⋮</span>
//               </div>
//               <div className="mt-4 h-48">
//                 <ResponsiveContainer width="100%" height="100%">
//                   <LineChart data={data}>
//                     <CartesianGrid strokeDasharray="3 3" />
//                     <XAxis dataKey="name" />
//                     <YAxis />
//                     <Tooltip />
//                     <Line type="monotone" dataKey="shipments" stroke="#8884d8" activeDot={{ r: 8 }} />
//                     <Line type="monotone" dataKey="boxes" stroke="#82ca9d" />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>

//             {/* Best Shipping Location */}
//             <div className={`rounded-custom mt-5 mb-5  shadow-custom-light ${isDarkMode ? "dark:bg-darkmodeColor dark:text-white dark:shadow-custom-dark" : "bg-white"}`}>
//               <div className="flex justify-between items-center mb-4">
//                 <div className="flex items-center space-x-3">
//                   <Package className={`w-6 h-6 ml-4 ${isDarkMode ? 'text-blue-300' : 'text-blue-600'}`} />
//                   <p className="text-xl font-medium mt-4 mb-4 ">Recent Orders</p>
//                 </div>
//                 <a
//                   href="/shipments/all"
//                   className={`
//             flex items-center space-x-2 
//             text-blue-500 
//             hover:text-blue-700 
//             transition-colors 
//             duration-2004
//             mr-4
//           `}
//                 >
//                   <span>View All Orders</span>
//                   <ArrowRight className="w-4 h-4 mr-4" />
//                 </a>
//               </div>
//             </div>
//             <div>
//               {(selectedRows.length > 0 || selectAll) && (
//                 <div className="mb-4">
//                   <Button
//                     onClick={handleDownload}
//                     disabled={isloading}
//                     sx={{
//                       color: "black", // Ensures text is black
//                       textTransform: "none", // Prevents automatic capitalization
//                     }}
//                     className="flex items-center gap-3  dark:text-white rounded-custom dark:shadow-custom-dark  shadow-custom-light  transition-all duration-200 font-medium"
//                   >
//                     {isloading ? (
//                       <div className="flex items-center gap-2">
//                         <Spinner className="w-4 h-4 animate-spin" />
//                         <span>Downloading...</span>
//                       </div>
//                     ) : (
//                       <div className="flex items-center gap-2">
//                         <FaDownload className="w-4 h-4" />
//                         <span>Download Selected ({selectAll ? currentItems.length : selectedRows.length})</span>
//                       </div>
//                     )}
//                   </Button>
//                 </div>
//               )}
//             </div>
//             <div className={`rounded-custom p-4 ${isDarkMode ? "dark:bg-darkmodeColor  rounded-custom text-white" : "bg-white "}`}>
//               <div className='overflow-x-auto'>
//                 <table className='min-w-full table-auto'>
//                   <thead className='bg-[#0540a6dd] text-white text-[12px]'>
//                     <tr>
//                       <th className='p-2 text-left'>
//                         <input
//                           type="checkbox"
//                           checked={selectAll}
//                           onChange={handleSelectAll}
//                         />
//                       </th>
//                       <th className='p-2 text-left'>OID</th>
//                       <th className='p-2 text-left'>UID</th>
//                       <th className='p-2 text-left'>Partner</th>
//                       <th className='p-2 text-left'>Customer Info</th>
//                       <th className='p-2 text-left'>WayBill No</th>
//                       <th className='p-2 text-left'>Shipping_Mode</th>
//                       <th className='p-2 text-left'>Status</th>
//                       <th className='p-2 text-left'>Charges</th>
//                       <th className='p-2 text-left'>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.map((shipment, index) => (
//                       <tr key={index} className='border-b'>
//                         <td className='p-2'>
//                           <input
//                             type="checkbox"
//                             checked={selectedRows.includes(index)}
//                             onChange={() => handleRowSelect(index)}
//                           />
//                         </td>
//                         <td className='p-2 text-sm'>{shipment.order_id}</td>
//                         <td className='p-2 text-sm'>{shipment.user_id}</td>
//                         <td className='p-2 text-sm'>{shipment.partner}</td>
//                         <td className='p-2 text-sm'>{shipment.first_name + shipment.last_name}</td>
//                         <td className='p-2 text-sm'>{shipment.waybill}</td>
//                         <td className='p-2 text-sm'>{shipment.shipping_mode}</td>
//                         <td className='p-2 text-sm'>{shipment.status}</td>
//                         <td className='p-2 text-sm'>₹{shipment.debit_amount || 'N/A'}</td>
//                         <td className='p-2 text-sm'>
//                           <div className='flex space-x-2'>
//                             <Button variant="contained" size="small"
//                               onClick={() => handleViewClick(shipment)}
//                               color="primary"><IoMdEye /></Button>
//                             {/* <Button variant="contained" size="small" color="secondary"><CiEdit /></Button> */}
//                             {/* <Button
//                               onClick={() => handlePrintLabel(shipment.order_id)}
//                               variant="contained"
//                               size="small"
//                               color="success"
//                             >
//                                 <FcPrint />
//                             </Button> */}

//                             <Button
//                               onClick={() => handlePrintLabel(shipment.order_id)}
//                               variant="contained"
//                               color="secondary"
//                               disabled={loadingOrderId === shipment.order_id}
//                             >
//                               {loadingOrderId === shipment.order_id ? (
//                                 <span className="animate-spin">
//                                   <FcPrint />
//                                 </span>
//                               ) : (
//                                 <FcPrint />
//                               )}
//                             </Button>
//                               <Button
//                                 onClick={() => handleCancelOrder(shipment.order_id)}
//                                 variant="contained"
//                                 color="error"
//                                 disabled={loadingOrderIdCancleOrder === shipment.order_id && shipment.status?.toLowerCase() !== 'cancel'}
//                               >
//                                 {loadingOrderIdCancleOrder === shipment.order_id ? (
//                                   <span className="animate-spin">⏳</span>
//                                 ) : (
//                                   <RxCross2 />
//                                 )}
//                               </Button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <ViewAllShipment isopen={isPopupOpen} onClose={handleClose} shipment={selectedShipment} />
//     </div>
//   );
// };

export default DashBoard;

